import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

/**
 * Tutorial video interface from API
 */
export interface TutorialVideo {
  _id: string;
  title: string;
  description?: string;
  vimeoId: string;
  keywords: string[];
  category: string;
  order: number;
  available: string;
  createdAt: Date;
  updatedAt: Date;
}

/**
 * Category interface
 */
export interface Category {
  key: string;
  label: string;
}

/**
 * API Response interface
 */
interface ApiResponse {
  videos: TutorialVideo[];
}

interface CategoriesResponse {
  categories: Category[];
}

@Injectable({
  providedIn: 'root'
})
export class TutorialVideosService {
  private baseUrl = environment.mkgoURL;

  constructor(private http: HttpClient) { }

  /**
   * Get all tutorial videos
   */
  getAllVideos(): Observable<TutorialVideo[]> {
    const url = `${this.baseUrl}/api/v1/general/tutorial-videos`;
    return this.http.get<ApiResponse>(url).pipe(
      map(response => response.videos || [])
    );
  }

  /**
   * Get all categories
   */
  getCategories(): Observable<Category[]> {
    const url = `${this.baseUrl}/api/v1/general/tutorial-videos/categories`;
    return this.http.get<CategoriesResponse>(url).pipe(
      map(response => response.categories || [])
    );
  }

  /**
   * Get video by ID
   */
  getVideoById(id: string): Observable<TutorialVideo> {
    const url = `${this.baseUrl}/api/v1/general/tutorial-videos/${id}`;
    return this.http.get<TutorialVideo>(url);
  }
}
